import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, useHistory } from 'react-router-dom';
import { loadableReady } from '@loadable/component';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import InterceptorClass from './lib/interceptor';
import store from './redux/store';

// sentry
import * as Sentry from "@sentry/react";
import { SENTRY_DSN_CSR, SENTRY_ERRORS_TO_IGNORE } from '../src/utilities/sentry/sentryConstants';
import { cleanErrors } from "../src/utilities/sentry/sentryHelpers";



const Interceptor = new InterceptorClass(store);
Interceptor.req();
Interceptor.res();

// initializes Sentry with browser history to track page/navigation for error tracking and performance monitoring
function SentryInitializer({ children }) {
    if (IS_SENTRY_TRACKING_ENABLED == 1) {
        const history = useHistory();
        useEffect(() => {
            Sentry.init({
                dsn: SENTRY_DSN_CSR,
                // debug: true, // use to debug sentry actions
                integrations: [
                    new Sentry.BrowserTracing({
                        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
                        tracePropagationTargets: ["localhost", /^https:\/\/magnitt\.com/, /^https:\/\/testapp\.magnitt\.com/],
                    }),
                    new Sentry.Replay({
                        maskAllText: false,
                        blockAllMedia: false,
                    }),
                ],
                environment: process.env.NODE_ENV,
                tracesSampleRate: 1.0,
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
                ignoreErrors: SENTRY_ERRORS_TO_IGNORE,
                beforeSend(event, hint) {
                    const error = hint.originalException;
                    return cleanErrors(event, error);
                },
            });
        }, [history]);
    } else {
        console.log('Not sending errors to sentry as it is disabled in .env file');
    }
    return children;
}

loadableReady(() => {

    const appElement = document.getElementById("app");

    if (appElement) {
        ReactDOM.hydrate(
            <HelmetProvider>
                <Provider store={store}>
                    <BrowserRouter>
                        <SentryInitializer>
                            <App />
                        </SentryInitializer>
                    </BrowserRouter>
                </Provider>
            </HelmetProvider>,
            appElement
        );
    }

});